import React from 'react'

import TextTruncate from 'react-text-truncate'



import {
  ModelCard,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, array, oneOf } from 'prop-types'

import Categories from 'Pods/Blog/Components/Categories/Categories'
import { imageUrlToAvoid } from 'Pods/Blog/Static/Constants'
import { headingsMap } from 'Pods/Blog/Static/HeadingsMap'

import { getDate } from 'Utils/FormatDate'
import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function Post({
  image = '',
  newImage = '',
  title: postTitle,
  shortText,
  publishDate = '',
  categories = EMPTY_ARRAY,
  layout = 'vertical',
  slug,
  titleComponent,
}) {
  const CustomTag = `${titleComponent}`
  const hasNewImage = !!newImage && !newImage.includes(imageUrlToAvoid)
  const imageSrc = hasNewImage ? newImage : image
  const categoriesIds = [...new Set(categories.map(({ id }) => id))]
  const uniqueCategories = categoriesIds.map((uniqueId) => categories.find(({ id }) => id === uniqueId))
  const postLink = `/blog/${slug}`

  function renderImage() {
    if (imageSrc) {
      return (
        <a href={postLink} className="blog-post-image-link">
          <img
            src={imageSrc}
            className={classnames('post-image-link__img', !hasNewImage && 'post-image-link__old-img')}
            alt="Post preview"
          />
        </a>
      )
    }

    return null
  }

  return (
    <ModelCard
      hasShadow
      customClass={classnames(layout === 'horizontal' && 'horizontal-post')}
    >
      <div
        className={classnames(
          'post-image',
          'cgt-legacy-back-color-brand-primary-10',
          layout === 'horizontal' && 'post-image--horizontal',
          !imageSrc && 'post-image--empty'
        )}
      >
        {renderImage()}
      </div>

      <div className="cgt-mt-10 cgt-mb-10 blog-post-content blog-post-content--section">
        <div className="blog-post-date">
          {publishDate && (
            <div className="cgt-legacy-text-caption cgt-legacy-color-typography-disabled">
              {getDate(publishDate)}
            </div>
          )}
        </div>
        <a href={postLink} className="blog-post-link">
          <CustomTag
            className={classnames(
              'cgt-legacy-heading-h5',
              'blog-post__text-title',
              'blog-post__text-title--small',
              layout === 'horizontal' ? 'blog-post__text-title--two-lines-soft' : 'blog-post__text-title--two-lines',
            )}
          >
            <TextTruncate text={postTitle} truncateText="..." line={2} />
          </CustomTag>
        </a>
        {shortText && layout === 'horizontal' && (
          <div
            className="blog-page-content__html"
            dangerouslySetInnerHTML={{ __html: shortText }}
          />
        )}

        <Categories list={uniqueCategories} />
      </div>
    </ModelCard>
  )
}

Post.propTypes = {
  title: string.isRequired,
  image: string,
  newImage: string,
  slug: string.isRequired,
  shortText: string.isRequired,
  publishDate: string,
  categories: array,
  layout: oneOf(['horizontal', 'vertical']),
  titleComponent: oneOf(headingsMap).isRequired,
}

export default Post
